import React from "react";
import { Box } from "app/components/common/Box/MainBox/MainBox";

interface Props {}

const Handle = ({}: Props) => {
  return (
    <Box
      marginTop={"sm"}
      marginBottom="sm"
      borderRadius={100}
      backgroundColor="neutral.100"
      width={40}
      height={4}
      alignSelf="center"
    />
  );
};

export default Handle;
